import React, { useState } from 'react';
import { LayoutComposer } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './CookiesPolicyPage.module.css';

const CookiesPolicyPage = () => {
    const [cookiePreferences, setCookiePreferences] = useState({
        necessary: true,
        analytics: false,
        marketing: false,
        functional: false
    });

    const handleToggle = (type) => {
        if (type === 'necessary') return; // Necessary cookies cannot be disabled
        setCookiePreferences(prev => ({
            ...prev,
            [type]: !prev[type]
        }));
    };

    const handleSavePreferences = () => {
        // Here you would save preferences to localStorage or send to backend
        localStorage.setItem('cookiePreferences', JSON.stringify(cookiePreferences));
        alert('Tus preferencias de cookies han sido guardadas.');
    };

    const layoutAreas = `
        topbar
        main
        footer
    `;

    return (
        <LayoutComposer areas={layoutAreas} className={css.root}>
            {layoutProps => {
                const { Topbar, Main, Footer } = layoutProps;
                return (
                    <>
                        <Topbar as="header" className={css.topbar}>
                            <TopbarContainer currentPage="CookiesPolicyPage" />
                        </Topbar>
                        <Main as="main" className={css.main}>
                            <div className={css.content}>
                                <h1 className={css.title}>Política de Cookies</h1>
                                <div className={css.lastUpdated}>
                                    Última actualización: {new Date().toLocaleDateString('es-ES')}
                                </div>
                                
                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>1. ¿Qué son las Cookies?</h2>
                                    <p className={css.text}>
                                        Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo 
                                        cuando visitas un sitio web. Nos ayudan a mejorar tu experiencia y a proporcionar 
                                        funcionalidades personalizadas.
                                    </p>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>2. Tipos de Cookies que Utilizamos</h2>
                                    
                                    <div className={css.cookieCategory}>
                                        <div className={css.categoryHeader}>
                                            <h3 className={css.categoryTitle}>Cookies Esenciales</h3>
                                            <div className={css.toggle}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={cookiePreferences.necessary}
                                                    disabled
                                                    className={css.checkbox}
                                                />
                                                <span className={css.slider}></span>
                                            </div>
                                        </div>
                                        <p className={css.categoryDescription}>
                                            Siempre activas. Son necesarias para el funcionamiento básico del sitio web.
                                        </p>
                                        <ul className={css.cookieList}>
                                            <li>Autenticación y seguridad</li>
                                            <li>Gestión de carrito de compras</li>
                                            <li>Preferencias básicas del usuario</li>
                                        </ul>
                                    </div>

                                    <div className={css.cookieCategory}>
                                        <div className={css.categoryHeader}>
                                            <h3 className={css.categoryTitle}>Cookies de Análisis</h3>
                                            <div className={css.toggle}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={cookiePreferences.analytics}
                                                    onChange={() => handleToggle('analytics')}
                                                    className={css.checkbox}
                                                />
                                                <span className={css.slider}></span>
                                            </div>
                                        </div>
                                        <p className={css.categoryDescription}>
                                            Nos ayudan a entender cómo interactúas con nuestro sitio web para mejorarlo.
                                        </p>
                                        <ul className={css.cookieList}>
                                            <li>Google Analytics</li>
                                            <li>Estadísticas de uso</li>
                                            <li>Análisis de comportamiento</li>
                                        </ul>
                                    </div>

                                    <div className={css.cookieCategory}>
                                        <div className={css.categoryHeader}>
                                            <h3 className={css.categoryTitle}>Cookies de Marketing</h3>
                                            <div className={css.toggle}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={cookiePreferences.marketing}
                                                    onChange={() => handleToggle('marketing')}
                                                    className={css.checkbox}
                                                />
                                                <span className={css.slider}></span>
                                            </div>
                                        </div>
                                        <p className={css.categoryDescription}>
                                            Se utilizan para mostrarte publicidad relevante basada en tus intereses.
                                        </p>
                                        <ul className={css.cookieList}>
                                            <li>Publicidad personalizada</li>
                                            <li>Seguimiento de conversiones</li>
                                            <li>Campañas de marketing</li>
                                        </ul>
                                    </div>

                                    <div className={css.cookieCategory}>
                                        <div className={css.categoryHeader}>
                                            <h3 className={css.categoryTitle}>Cookies Funcionales</h3>
                                            <div className={css.toggle}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={cookiePreferences.functional}
                                                    onChange={() => handleToggle('functional')}
                                                    className={css.checkbox}
                                                />
                                                <span className={css.slider}></span>
                                            </div>
                                        </div>
                                        <p className={css.categoryDescription}>
                                            Mejoran la funcionalidad del sitio web recordando tus preferencias.
                                        </p>
                                        <ul className={css.cookieList}>
                                            <li>Idioma preferido</li>
                                            <li>Ubicación para mostrar contenido local</li>
                                            <li>Personalización de la interfaz</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>3. Duración de las Cookies</h2>
                                    <ul className={css.list}>
                                        <li><strong>Cookies de sesión:</strong> Se eliminan cuando cierras el navegador</li>
                                        <li><strong>Cookies persistentes:</strong> Permanecen en tu dispositivo durante un período específico</li>
                                        <li><strong>Cookies de terceros:</strong> Establecidas por servicios externos que utilizamos</li>
                                    </ul>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>4. Gestión de Cookies</h2>
                                    <p className={css.text}>
                                        Puedes gestionar tus preferencias de cookies de varias maneras:
                                    </p>
                                    <ul className={css.list}>
                                        <li>A través de este panel de configuración</li>
                                        <li>Configurando tu navegador web</li>
                                        <li>Utilizando herramientas de gestión de privacidad</li>
                                        <li>Borrando cookies almacenadas en tu dispositivo</li>
                                    </ul>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>5. Cookies de Terceros</h2>
                                    <p className={css.text}>
                                        Utilizamos servicios de terceros que pueden instalar sus propias cookies:
                                    </p>
                                    <div className={css.thirdPartyTable}>
                                        <div className={css.tableHeader}>
                                            <span>Servicio</span>
                                            <span>Finalidad</span>
                                            <span>Duración</span>
                                        </div>
                                        <div className={css.tableRow}>
                                            <span>Google Analytics</span>
                                            <span>Análisis de tráfico</span>
                                            <span>2 años</span>
                                        </div>
                                        <div className={css.tableRow}>
                                            <span>Stripe</span>
                                            <span>Procesamiento de pagos</span>
                                            <span>Sesión</span>
                                        </div>
                                        <div className={css.tableRow}>
                                            <span>Mapbox/Google Maps</span>
                                            <span>Visualización de mapas</span>
                                            <span>Sesión</span>
                                        </div>
                                    </div>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>6. Impacto de Desactivar Cookies</h2>
                                    <p className={css.text}>
                                        Si desactivas ciertas cookies, algunas funcionalidades del sitio pueden 
                                        no funcionar correctamente. Las cookies esenciales siempre estarán activadas 
                                        para garantizar el funcionamiento básico de la plataforma.
                                    </p>
                                </div>

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>7. Actualizaciones de la Política</h2>
                                    <p className={css.text}>
                                        Esta política puede actualizarse periódicamente para reflejar cambios en 
                                        nuestras prácticas o en la legislación aplicable. Te recomendamos revisarla 
                                        regularmente.
                                    </p>
                                </div>

                        

                                <div className={css.section}>
                                    <h2 className={css.sectionTitle}>9. Contacto</h2>
                                    <p className={css.text}>
                                        Para cualquier pregunta sobre nuestra política de cookies:
                                    </p>
                                    <p className={css.contact}>
                                        Email: contacto@biocerca.es<br />
                                        Teléfono: 696867268
                                    </p>
                                </div>
                            </div>
                        </Main>
                        <Footer>
                            <FooterContainer />
                        </Footer>
                    </>
                );
            }}
        </LayoutComposer>
    );
};

export default CookiesPolicyPage;
